import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Activities.css'; // Custom styles
import API_URL from '../../api/ExamCalendarApi';

const Activities = () => {
  const [activities, setActivities] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    logo: null,
  });
  const [editActivityId, setEditActivityId] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  // Fetch all activities
  const fetchActivities = async () => {
    try {
      const response = await axios.get(`${API_URL}/homepage/activities/get-all`);
      setActivities(response.data.activities);
    } catch (error) {
      console.error('Error fetching activities:', error);
      setErrorMessage('Failed to fetch activities.');
    }
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  // Handle form changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: files ? files[0] : value,
    }));
  };

  // Handle form submit (Add or Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formPayload = new FormData();
    formPayload.append('title', formData.title);
    formPayload.append('content', formData.content);
    if (formData.logo) {
      formPayload.append('logo', formData.logo);
    }

    try {
      if (editActivityId) {
        // Update activity
        await axios.put(`${API_URL}/homepage/activities/update/${editActivityId}`, formPayload);
        setEditActivityId(null);
      } else {
        // Add new activity
        await axios.post(`${API_URL}/homepage/add-activity`, formPayload);
      }
      setFormData({ title: '', content: '', logo: null });
      fetchActivities();
    } catch (error) {
      console.error('Error saving activity:', error);
      setErrorMessage('Failed to save activity.');
    }
  };

  // Handle delete activity
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this activity?')) {
      try {
        await axios.delete(`${API_URL}/homepage/activities/delete/${id}`);
        fetchActivities();
      } catch (error) {
        console.error('Error deleting activity:', error);
        setErrorMessage('Failed to delete activity.');
      }
    }
  };

  // Handle edit activity
  const handleEdit = (activity) => {
    setEditActivityId(activity._id);
    setFormData({
      title: activity.title,
      content: activity.content,
      logo: null, // Reset logo as it's not needed unless updating
    });
  };

  return (
    <div className="admin-activities-container">
      <h2 className="admin-activities-title">Preparation Activities Management</h2>

      {errorMessage && <div className="admin-activities-alert">{errorMessage}</div>}

      <form onSubmit={handleSubmit} className="admin-activities-form">
        <div className="admin-activities-form-group">
          <label>Activity Title</label>
          <input
            type="text"
            name="title"
            className="admin-activities-input"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="admin-activities-form-group">
          <label>Activity Content</label>
          <textarea
            name="content"
            className="admin-activities-textarea"
            value={formData.content}
            onChange={handleChange}
            required
          />
        </div>

        <div className="admin-activities-form-group">
          <label>Activity Logo</label>
          <input
            type="file"
            name="logo"
            className="admin-activities-file-input"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="admin-activities-button">
          {editActivityId ? 'Update Activity' : 'Add Activity'}
        </button>
      </form>

      <h4 className="admin-activities-subtitle">All Activities</h4>
      <div className="admin-activities-table-wrapper">
      <table className="admin-activities-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Content</th>
            <th>Logo</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {activities.map((activity) => (
            <tr key={activity._id}>
              <td>{activity.title}</td>
              <td>{activity.content}</td>
              <td>
                {activity.logo && (
                  <img
                    src={activity.logo}
                    alt={activity.title}
                    className="admin-activities-logo"
                  />
                )}
              </td>
              <td className="admin-activities-actions">
                <button
                  className="admin-activities-edit-button"
                  onClick={() => handleEdit(activity)}
                >
                  Edit
                </button>
                <button
                  className="admin-activities-delete-button"
                  onClick={() => handleDelete(activity._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Activities;